import React from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { Link } from 'react-router-dom';

import { useAppSelector } from '../../hooks';
import { BreadcrumbState } from '../../reducers/breadcrumbReducer';

const Breadcrumbs = () => {
  const breadcrumbs: BreadcrumbState | undefined = useAppSelector((state) => state.breadcrumbs);
  if (!breadcrumbs || breadcrumbs.length < 1) return null;

  const finalIndex = breadcrumbs.length - 1;

  const makeBreadcrumbItem = (label: string, link?: string, isFinal?: boolean) => {
    const inner = link ? <Link to={link}>{label}</Link> : label;
    if (isFinal) {
      return (
        <BreadcrumbItem key={label} active>
          {inner}
        </BreadcrumbItem>
      );
    } else {
      return <BreadcrumbItem key={label}>{inner}</BreadcrumbItem>;
    }
  };

  return (
    <div className={'breadcrumbContainer'}>
      <Breadcrumb>
        {breadcrumbs.map(({ label, link }, index) => makeBreadcrumbItem(label, link, index === finalIndex))}
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
